var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector"},[_c('BaseButtonGroup',{attrs:{"value":_vm.activePreset,"options":_vm.presetsOptions},on:{"input":_vm.setActivePreset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }